import { z } from 'zod';
import { OrgNicheSchema } from './org-schemas.js';
// Shared between backend (controller DTO + use case input) and frontend (form
// + API client). Locations are org-scoped operational units managed by Org
// Admins (JQ4-10 / US-ORG-002).
export const LocationStatusSchema = z.enum(['active', 'inactive']);
export const CreateLocationRequestSchema = z.object({
    name: z.string().trim().min(1, 'Name is required').max(120),
    address: z.string().trim().min(1, 'Address required').max(255),
    timezone: z.string().trim().min(1, 'Timezone is required').max(64),
    currency: z
        .string()
        .regex(/^[A-Z]{3}$/, 'Currency must be ISO 4217 (3 uppercase letters)')
        .default('USD'),
    niche: OrgNicheSchema,
    vehicleCapacity: z.number().int().min(0).max(99999).nullable().optional(),
});
export const UpdateLocationRequestSchema = CreateLocationRequestSchema.partial();
export const LocationResponseSchema = z.object({
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    name: z.string(),
    address: z.string(),
    timezone: z.string(),
    currency: z.string(),
    niche: OrgNicheSchema,
    vehicleCapacity: z.number().int().nullable(),
    status: LocationStatusSchema,
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const ListLocationsResponseSchema = z.object({
    locations: z.array(LocationResponseSchema),
});
//# sourceMappingURL=location-schemas.js.map